import React from 'react'
import WhoHero from '../Components/who/WhoHero'
import FounderSection from '../Components/customer/FounderSection'
import LeadershipTeam from '../Components/customer/LeadershipTeam'
import { Helmet } from "react-helmet-async";

function Customer() {
    return (
        <div>
            <Helmet>
    <title>
        Customer Speak | Client Experiences & Testimonials | Mobikode
    </title>

    <meta
        name="description"
        content="Hear what Mobikode customers have to say about their experiences, partnerships, Enterprise AI & ServiceNow Consulting journeys, and the value delivered through our technology solutions."
    />

    <meta
        name="keywords"
        content="Mobikode Customer Speak, Mobikode Testimonials, Customer Testimonials, Client Testimonials, Mobikode Reviews, Customer Experiences, Client Experiences, Technology Partner Reviews, Enterprise AI & ServiceNow Consulting Testimonials, Mobikode Customer Stories, IT Company Testimonials"
    />

    <link
        rel="canonical"
        href="https://www.mobikode.com/customer-speak"
    />

    <meta
        property="og:title"
        content="Customer Speak | Client Experiences & Testimonials | Mobikode"
    />

    <meta
        property="og:description"
        content="Explore customer experiences and testimonials from businesses that have partnered with Mobikode for technology, Enterprise AI & ServiceNow Consulting, and software solutions."
    />

    <meta
        property="og:url"
        content="https://www.mobikode.com/customer-speak"
    />

    <meta
        property="og:type"
        content="website"
    />

    <meta
        property="og:image"
        content="https://www.mobikode.com/assets/customer/bg1.png"
    />

    <meta
        name="twitter:card"
        content="summary_large_image"
    />

    <meta
        name="twitter:title"
        content="Customer Speak | Client Experiences & Testimonials | Mobikode"
    />

    <meta
        name="twitter:description"
        content="Read customer experiences and testimonials highlighting Mobikode's technology expertise, partnerships, and Enterprise AI & ServiceNow Consulting solutions."
    />

    <meta
        name="twitter:image"
        content="https://www.mobikode.com/assets/customer/bg1.png"
    />
</Helmet>
            <WhoHero
                title="Customer Speak"
                // text="Driving smart connections and experiences for a sustainable tomorrow."
                imgData="/assets/customer/bg1.png"
            />
            <FounderSection />
            <LeadershipTeam />
        </div>
    )
}

export default Customer
